import $ from "jquery";

function rfMaximizeWidthIsTrue(val) {
  if (val === true || val === 1) return true;
  if (val === false || val === 0 || val === null || typeof val === "undefined") return false;
  var s = String(val).toLowerCase();
  return s === "true" || s === "1" || s === "wahr" || s === "ja" || s === "yes" || s === "on";
}

function rfMaximizeWidthApply(gridId, prefKey, $btn) {
  var $grid = $("#" + gridId);
  if (!$grid.length) return;
  var $input = $('input#' + prefKey + ', input[name="' + prefKey + '"]').first();
  if (!$input.length) return;

  var on = rfMaximizeWidthIsTrue($input.val());
  if (on) {
    $grid.addClass("maximized");
    $btn.addClass("options_button_focus");
  } else {
    $grid.removeClass("maximized");
    $btn.removeClass("options_button_focus");
  }
}

export function rfMaximizeWidthApplyAll() {
  $(".js-maximize-width-toggle").each(function () {
    var $btn = $(this);
    rfMaximizeWidthApply($btn.data("maximizeGrid"), $btn.data("maximizePref"), $btn);
  });
}

function rfMaximizeWidthToggle($btn) {
  var gridId = $btn.data("maximizeGrid");
  var prefKey = $btn.data("maximizePref");
  var $input = $('input#' + prefKey + ', input[name="' + prefKey + '"]').first();
  if (!$input.length) return;

  var on = rfMaximizeWidthIsTrue($input.val());
  $input.val(on ? "false" : "true");

  if (typeof window.ajax_set_session_pref === "function") {
    window.ajax_set_session_pref(prefKey, $input.val());
  }

  rfMaximizeWidthApply(gridId, prefKey, $btn);
}

$(document).on("click", ".js-maximize-width-toggle", function (e) {
  e.preventDefault();
  rfMaximizeWidthToggle($(this));
});

document.addEventListener("DOMContentLoaded", function () {
  rfMaximizeWidthApplyAll();
});

window.rfMaximizeWidthApplyAll = rfMaximizeWidthApplyAll;
